import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'
import * as commonSelectors from '../selectors'
import './loader.css'

export const Loader = ({
    isloading = null,
}) => {
    const loadingSelect = useSelector(commonSelectors.loading);
    const [isVisible, setVisible] = useState(false);
    const [iconsVisible, setIconsVisible] = useState(true);
    const refIsUnmounted = useRef(false);
    const refVisible = useRef(isVisible);

    useEffect(() => {
        const loading = isloading == null ? loadingSelect : isloading;
        if (loading !== isVisible) {
            _setVisible(loading);
            if (loading) {
                setIconsVisible(true);
            } else {
                setTimeout(() => {
                    if (!refIsUnmounted.current || !refVisible.current) {
                        setIconsVisible(false);
                    }
                }, 750) //  750 == .bon-loader-frametransition time
            }
        }

        return () => {
            refIsUnmounted.current = true;
        }
    }, [loadingSelect, isVisible, isloading])

    const _setVisible = bool => {
        refVisible.current = bool;
        setVisible(bool);   
    }

    return (
        <div
            className='bon-loader-frame'
            data-visible={isVisible}
        >
            {iconsVisible &&
                <div className='icon-wrapper'>
                    <ThreeCirclesAnimatedSvg />
                </div>
            }
        </div>
    );
}

export const ThreeCirclesAnimatedSvg = () => {
    return (
        <svg
            viewBox="0 0 180 30"
            xmlns="http://www.w3.org/2000/svg"
            className="bon-three-circles"
        >
            <circle cx="30" cy="15" r="30" />
            <circle cx="90" cy="15" r="30" />
            <circle cx="150" cy="15" r="30" />
        </svg>
    );
}

export default Loader;
